export type TeamMember = {
  color: string;
  createdAt: string;
  email: string;
  id: string;
  name: string;
  role: string;
  startDate: string;
  updatedAt: string;
};

// Company-wide annual paid-time-off entitlement, prorated for mid-year joiners.
export const ANNUAL_PTO_DAYS = 24;

export type Vacation = {
  createdAt: string;
  endDate: string;
  id: string;
  notes: null | string;
  startDate: string;
  teamMember: TeamMember;
  teamMemberId: string;
  updatedAt: string;
};

export enum HolidayRegion {
  EUROPE = 'europe',
  GENERAL = 'general',
  UAE = 'uae',
  UKRAINE = 'ukraine',
}

export const HolidayRegionTitle: Record<HolidayRegion, string> = {
  [HolidayRegion.EUROPE]: 'Europe',
  [HolidayRegion.GENERAL]: 'General',
  [HolidayRegion.UAE]: 'UAE',
  [HolidayRegion.UKRAINE]: 'Ukraine',
};

// Flag shown next to a holiday. "General" (universal days like New Year) uses a globe.
export const HolidayRegionFlag: Record<HolidayRegion, string> = {
  [HolidayRegion.EUROPE]: '🇪🇺',
  [HolidayRegion.GENERAL]: '🌍',
  [HolidayRegion.UAE]: '🇦🇪',
  [HolidayRegion.UKRAINE]: '🇺🇦',
};

// Banner accent per region so holidays are visually distinct from personal vacations.
export const HolidayRegionColor: Record<HolidayRegion, string> = {
  [HolidayRegion.EUROPE]: '#7A5AF8',
  [HolidayRegion.GENERAL]: '#475467',
  [HolidayRegion.UAE]: '#039855',
  [HolidayRegion.UKRAINE]: '#2565C8',
};

export type PublicHoliday = {
  createdAt: string;
  date: string;
  id: string;
  name: string;
  region: HolidayRegion;
  updatedAt: string;
};

export enum TeamTabType {
  MEMBERS = 'members',
  VACATIONS = 'vacations',
}

export const TeamTabTitle: Record<TeamTabType, string> = {
  [TeamTabType.MEMBERS]: 'Members',
  [TeamTabType.VACATIONS]: 'Vacations',
};

export const arrayOfTeamTab = Object.entries(TeamTabTitle) as [TeamTabType, string][];

export enum VacationView {
  CALENDAR = 'calendar',
  LIST = 'list',
}

// Suggested titles for the roster form. Free text — real titles vary, so this is a hint list, not a
// closed enum (hence a plain string[] rather than an `as const` domain type).
export const TEAM_ROLE_SUGGESTIONS: string[] = [
  'Developer',
  'Designer',
  'QA',
  'Product Manager',
  'Business development representative',
  'Chief Revenue Officer',
  'Founder, CEO / CFO',
  'Founder, CPO',
];

export const getInitials = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
